import ConfigProvider from 'antd/lib/config-provider'
import React, { useContext } from 'react'
import { ThemeProvider, useTheme } from '../components/core/ThemeProvider/ThemeProvider'
import { AuthContext } from '../context/firebase-context'
import UnpaidBanner, { PAYMENT_FAILED_STATUSES } from '../components/shared/unpaid-banner'
import NewVersionBanner from '../components/shared/NewVersion'

const EditorConfigProvider = ({ children }) => {
  const user = useContext(AuthContext)
  const { themeMode } = useTheme()
  return (
    <ConfigProvider
      modal={{
        className: `nolanModal ${themeMode}`
      }}
      steps={{
        className: `nolanSteps ${themeMode}`
      }}
      drawer={{
        className: `nolanDrawer ${themeMode}`
      }}
      slider={{
        className: `nolanSlider ${themeMode}`
      }}
      alert={{
        className: `nolanAlert ${themeMode}`
      }}
      progress={{
        className: `nolanProgress ${themeMode}`
      }}
      typography={{
        className: `nolan-typography ${themeMode}`
      }}
      notification={{
        className: `nolanNotification ${themeMode}`
      }}
      form={{
        className: `nolanForm ${themeMode}`
      }}
      menu={{
        className: `nolanMenu ${themeMode}`
      }}
      select={{
        className: `nolanSelect ${themeMode}`
      }}
      input={{
        className: `nolan-input ${themeMode}`
      }}
      table={{
        className: `nolan-table ${themeMode}`
      }}
      textArea={{
        className: `nolan-input ${themeMode}`
      }}
      switch={{
        className: `nolanSwitch ${themeMode}`
      }}
      tooltip={{
        className: `nolanTooltip ${themeMode}`
      }}
      theme={{
        components: {
          Tooltip: {
            fontSize: 11
          },
          Button: {
            colorPrimary: '#1D6EE3',
            borderRadius: '96px'
            // algorithm: true, // Enable algorithm
          },
          Typography: {

          },
          Input: {
            activeBg: 'transparent',
            hoverBg: 'unset',
            activeShadow: 'unset',
            activeBorderColor: 'rgba(26, 29, 36, 0.44)',
            hoverBorderColor: 'rgba(26, 29, 36, 0.44)'
          },
          InputNumber: {
            activeBg: 'transparent',
            hoverBg: 'unset',
            activeShadow: 'unset',
            activeBorderColor: 'rgba(26, 29, 36, 0.44)',
            hoverBorderColor: 'rgba(26, 29, 36, 0.44)'
          },
          Table: {
            borderRadius: 'unset'
          },
          Switch: {
            ba: '#007bff'
          }
        },
        token: {
          colorPrimary: '#1D6EE3',
          borderRadius: 8,
          fontFamily: 'Lexend Deca'
        }
      }}
    >
      {(user && PAYMENT_FAILED_STATUSES.includes(user.subscriptionStatus)) && (<UnpaidBanner isBanner sticky user={user} />)}
      <NewVersionBanner />
      {children}
    </ConfigProvider>
  )
}

const EditorConfig = ({ children }) => {
  return (
    <ThemeProvider>
      <EditorConfigProvider>
        {children}
      </EditorConfigProvider>
    </ThemeProvider>
  )
}

export default EditorConfig
